<div class="no-transaction">
  <div class="no-transaction__img-container">
    <img class="no-transaction__img" alt="" src="assets/icons/document-icon.svg" />
  </div>
  <span class="no-transaction__info-title">{{noDataMsg|translate}}</span>
  <ng-container *ngIf="!isSearchResult">
    <span class="no-transaction__info-desc">{{subMsg1|translate}}</span>
  </ng-container>
</div>



